import { render } from "./ManageLearningCourseCertification.vue?vue&type=template&id=26af6f8d&lang=pug"
import script from "./ManageLearningCourseCertification.vue?vue&type=script&lang=js"
export * from "./ManageLearningCourseCertification.vue?vue&type=script&lang=js"

import "./ManageLearningCourseCertification.vue?vue&type=style&index=0&id=26af6f8d&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__